var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10H15V13.3333H13.3333V10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5.83333V4.16667C16.6667 3.2475 15.9192 2.5 15 2.5H4.16667C2.78834 2.5 1.66667 3.62167 1.66667 5V15C1.66667 16.8342 3.16167 17.5 4.16667 17.5H16.6667C17.5858 17.5 18.3333 16.7525 18.3333 15.8333V7.5C18.3333 6.58083 17.5858 5.83333 16.6667 5.83333ZM4.16667 4.16667H15V5.83333H4.16667C3.95211 5.82374 3.74951 5.73174 3.60107 5.57651C3.45263 5.42129 3.36978 5.21478 3.36978 5C3.36978 4.78522 3.45263 4.57871 3.60107 4.42349C3.74951 4.26826 3.95211 4.17626 4.16667 4.16667ZM16.6667 15.8333H4.17667C3.79167 15.8233 3.33334 15.6708 3.33334 15V7.34583C3.59501 7.44 3.8725 7.5 4.16667 7.5H16.6667V15.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.cafe1909a9da5ee4d479c9c4f82d2f94.svg";
export { ForwardRef as ReactComponent };